"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRadioGroup = require("react-radio-group");

var _formElements = require("@evidation/form-elements");

var _icons = require("@evidation/ui/lib/icons");

var Table = _styledComponents["default"].table.withConfig({
  displayName: "desktop__Table"
})(["width:100%;tr{& > th,& > td{line-height:20px;width:67%;p{margin:0;padding:0;}&.firstColumn{width:33%;text-align:left;.icon-container{flex:0 0 auto;width:18px;margin-right:10px;svg path{fill:orange;}}}&.error-icon-cell{width:20px;}}th{vertical-align:bottom;}}&.has-errors{.error-icon-cell{border-right:none;}.firstColumn{border-left:none;}}"]);

var RadioContainer = _styledComponents["default"].div.withConfig({
  displayName: "desktop__RadioContainer"
})(["width:", ";display:inline-block;text-align:center;cursor:", ";input[type='radio']{position:relative;opacity:1;cursor:inherit;}"], function (p) {
  return p.containerWidth;
}, function (p) {
  return p.disabled ? "default" : "pointer";
});

var RadioInput = function RadioInput(_ref) {
  var index = _ref.index,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      containerWidth = _ref.containerWidth;
  return /*#__PURE__*/_react["default"].createElement(RadioContainer, {
    containerWidth: containerWidth,
    disabled: disabled,
    onClick: function onClick(e) {
      onChange((0, _defineProperty2["default"])({}, index, value));
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.Radio, {
    "data-test-id": "radio_".concat(index, "_").concat(value),
    id: "radio_".concat(index, "_").concat(value),
    value: value,
    readOnly: true,
    disabled: disabled
  }));
};

var Desktop = function Desktop(_ref2) {
  var question_label = _ref2.question_label,
      answer_labels = _ref2.answer_labels,
      questions = _ref2.questions,
      onChange = _ref2.onChange,
      values = _ref2.values,
      disabled = _ref2.disabled,
      inter = _ref2.inter,
      getQuestionKey = _ref2.getQuestionKey,
      hideFirstColumn = _ref2.hideFirstColumn,
      _ref2$errorRowIndexes = _ref2.errorRowIndexes,
      errorRowIndexes = _ref2$errorRowIndexes === void 0 ? [] : _ref2$errorRowIndexes,
      rowRefs = _ref2.rowRefs;
  var radioContainerWidth = "".concat(100 / answer_labels.length, "%");
  var hasAnyErrors = errorRowIndexes.length > 0;
  return /*#__PURE__*/_react["default"].createElement(Table, {
    className: hasAnyErrors ? 'has-errors' : '',
    "data-test": "desktop_questionaire"
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, hasAnyErrors && /*#__PURE__*/_react["default"].createElement("th", {
    className: "error-icon-cell"
  }), !hideFirstColumn && /*#__PURE__*/_react["default"].createElement("th", {
    className: "firstColumn"
  }, question_label), /*#__PURE__*/_react["default"].createElement("th", null, _lodash["default"].map(answer_labels, function (answer, index) {
    return /*#__PURE__*/_react["default"].createElement(RadioContainer, {
      containerWidth: radioContainerWidth,
      disabled: true,
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, answer));
  })))), /*#__PURE__*/_react["default"].createElement("tbody", null, _lodash["default"].map(questions, function (question, index) {
    var questionIndex = getQuestionKey ? getQuestionKey(index) : "".concat(inter, "_").concat(index);
    var hasError = errorRowIndexes.includes(index);
    return /*#__PURE__*/_react["default"].createElement("tr", {
      ref: rowRefs && function (ref) {
        rowRefs.current[index] = ref;
      },
      key: index
    }, hasAnyErrors && /*#__PURE__*/_react["default"].createElement("td", {
      className: "error-icon-cell"
    }, hasError && /*#__PURE__*/_react["default"].createElement(_icons.WarningSignFilled, null)), !hideFirstColumn && /*#__PURE__*/_react["default"].createElement("td", {
      className: "firstColumn"
    }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, question)), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.RadioGroup, {
      selectedValue: !_lodash["default"].isUndefined(values[questionIndex]) ? values[questionIndex] : '',
      name: questionIndex
    }, _lodash["default"].map(answer_labels, function (answer, index) {
      return /*#__PURE__*/_react["default"].createElement(RadioInput, {
        containerWidth: radioContainerWidth,
        key: "".concat(questionIndex, "_").concat(index),
        index: questionIndex,
        value: index,
        onChange: !disabled && onChange,
        disabled: disabled
      });
    }))));
  })));
};

Desktop.defaultProps = {
  values: {}
};
Desktop.propTypes = {
  inter: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  values: _propTypes["default"].object,
  getQuestionKey: _propTypes["default"].func
};
var _default = Desktop;
exports["default"] = _default;